/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query IpReadUniqueQuery($ipId: ID!) {
  IpReadUnique(ipId: $ipId) {
    id,
    ip,
    message,
    status
  }
}
`
